const Svg = (
  <svg
    viewBox="0 0 54 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={"100%"}
    height={"100%"}
  >
    <g>
      <path
        d="M44.68 9.22023C43.6585 8.19824 42.4456 7.38753 41.1107 6.8344C39.7758 6.28128 38.345 5.99658 36.9 5.99658C35.455 5.99658 34.0242 6.28128 32.6893 6.8344C31.3544 7.38753 30.1415 8.19824 29.12 9.22023L27 11.3402L24.88 9.22023C22.8166 7.15685 20.0181 5.99765 17.1 5.99765C14.1819 5.99765 11.3834 7.15685 9.31999 9.22023C7.25661 11.2836 6.09741 14.0822 6.09741 17.0002C6.09741 19.9183 7.25661 22.7168 9.31999 24.7802L27 42.4602L44.68 24.7802C45.702 23.7587 46.5127 22.5459 47.0658 21.2109C47.6189 19.876 47.9036 18.4452 47.9036 17.0002C47.9036 15.5553 47.6189 14.1244 47.0658 12.7895C46.5127 11.4546 45.702 10.2417 44.68 9.22023Z"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Svg;
